// extracted by mini-css-extract-plugin
export default {"doughnut":"DoughnutChart_doughnut__1eM29"};